// import React from 'react'
// import { Button, Form, Input, Modal, Panel } from 'rsuite'
// import FormControlLabel from 'rsuite/esm/FormControlLabel'

// const Email = ({size, open, handleClose, to, setTo, subject, setSubject, Textarea, message, setMessage, sendemail, handleAttachmentChange}) => {
//   return (
//     <div>
//       <Modal size={size} open={open} onClose={handleClose} backdrop="static">
//             <Modal.Header>
//               <Modal.Title>
//                 <b>Query</b>
//               </Modal.Title>
//             </Modal.Header>
//             <Modal.Body style={{ justifyContent: 'center' }}>
//               <Panel style={{ width: '60%', margin: 'auto' }}>
//                 <Form>
//                   <FormControlLabel>To:</FormControlLabel>
//                   <Input value={to} onChange={value => setTo(value)} />
//                   <FormControlLabel>Subject</FormControlLabel>
//                   <Input value={subject} onChange={value => setSubject(value)} />
//                   <FormControlLabel>Body</FormControlLabel>
//                   <Form.Control
//                     rows={5}
//                     name="textarea"
//                     accepter={Textarea}
//                     value={message}
//                     onChange={value => setMessage(value)}
//                   />
//                   <FormControlLabel>Attachment</FormControlLabel>
//                       <input type="file" onChange={handleAttachmentChange} style={{opacity: 1}}/>
//                 </Form>
//               </Panel>
//             </Modal.Body>
//             <Modal.Footer>
//               <Button onClick={handleClose} appearance="subtle" active>
//                 Cancel
//               </Button>
//               <Button onClick={sendemail} appearance="primary" color="cyan">
//                 Send
//               </Button>
//             </Modal.Footer>
//           </Modal>
//     </div>
//   )
// }

// export default Email

// Email.tsx - Updated component
import React from 'react'
import { Button, Form, Input, Modal, Panel } from 'rsuite'
import FormControlLabel from 'rsuite/esm/FormControlLabel'

const Email = ({
  size, 
  open, 
  handleClose, 
  to, 
  setTo, 
  subject, 
  setSubject, 
  Textarea, 
  message, 
  setMessage, 
  loading,
  sendemail, 
  handleAttachmentChange,
  attachment,
    onRemoveAttachment
}) => {
  return (
    <div>
      <Modal size={size} open={open} onClose={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>
            <b>Send Quotation via Email</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ justifyContent: 'center' }}>
          <Panel style={{ width: '60%', margin: 'auto' }}>
            <Form>
              <FormControlLabel>To:</FormControlLabel>
              <Input 
                value={to} 
                onChange={value => setTo(value)} 
                placeholder="Enter recipient email"
              />
              
              <FormControlLabel>Subject</FormControlLabel>
              <Input value={subject} onChange={value => setSubject(value)} />
              
              <FormControlLabel>Message</FormControlLabel>
              <Form.Control
                rows={5}
                name="textarea"
                accepter={Textarea}
                value={message}
                onChange={value => setMessage(value)}
              />
              
              {/* <FormControlLabel>Attachment</FormControlLabel>
              <div style={{ marginBottom: '15px' }}>
                <input 
                  type="file" 
                  onChange={handleAttachmentChange} 
                  style={{ opacity: 1, marginBottom: '10px' }}
                  accept=".pdf,.xlsx,.xls"
                />
          
                {attachment && attachment.filename && (
                  <div style={{ 
                    marginTop: '5px', 
                    padding: '8px', 
                    backgroundColor: '#e8f5e8', 
                    borderRadius: '4px',
                    fontSize: '12px',
                    border: '1px solid #4caf50'
                  }}>
                    ✅ Attachment: {attachment.filename}
                  </div>
                )}
                {!attachment?.filename && (
                  <div style={{ 
                    marginTop: '5px', 
                    padding: '8px', 
                    backgroundColor: '#fff3cd', 
                    borderRadius: '4px',
                    fontSize: '12px',
                    border: '1px solid #ffc107'
                  }}>
                    ℹ️ No attachment selected. You can add the downloaded quotation file.
                  </div>
                )}
              </div> */}
<FormControlLabel>Attachment</FormControlLabel>
<div style={{ marginBottom: '15px' }}>
  <input 
    type="file" 
    onChange={handleAttachmentChange} 
    style={{ opacity: 1, marginBottom: '10px' }}
    accept=".pdf,.xlsx,.xls"
  />
  
  {/* Show selected file with remove option */}
  {attachment && attachment.filename && (
    <div style={{ 
      marginTop: '5px', 
      padding: '8px', 
      backgroundColor: '#e8f5e8', 
      borderRadius: '4px',
      fontSize: '12px',
      border: '1px solid #4caf50',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}>
      <span>
        ✅ Attachment: {attachment.filename}
        {attachment.source === 'api' && (
          <span style={{ fontSize: '10px', color: '#666', marginLeft: '8px' }}>
            (Auto-attached from download)
          </span>
        )}
        {attachment.source === 'manual' && (
          <span style={{ fontSize: '10px', color: '#666', marginLeft: '8px' }}>
            (Manually uploaded)
          </span>
        )}
      </span>
      <Button 
        size="xs" 
        appearance="subtle" 
        onClick={onRemoveAttachment}
        style={{ color: 'red' }}
      >
        Remove
      </Button>
    </div>
  )}
  
  {!attachment?.filename && (
    <div style={{ 
      marginTop: '5px', 
      padding: '8px', 
      backgroundColor: '#fff3cd', 
      borderRadius: '4px',
      fontSize: '12px',
      border: '1px solid #ffc107'
    }}>
      ℹ️ No attachment selected. Email will be sent without attachment.
    </div>
  )}
</div>
            </Form>
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} appearance="subtle">
            Cancel
          </Button>
          <Button onClick={sendemail} appearance="primary" color="cyan" disabled={loading}>
            Send Email
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default Email